import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import SwatchOption from './product-options/swatch-option';
import RadioOption from './product-options/radio-option';
import SelectOption from './product-options/select-option';

const VariantSelector = (props) => {
  const { currentVariant } = props;

 
  const [isFromLastCollection, setIsFromLastCollection] = useState(
    () => localStorage.getItem('lastVisitedCollection')
  );
  

  useEffect(() => {
    const lastCollection = localStorage.getItem('lastVisitedCollection');
    const referrer = document.referrer || "";

    if (!referrer.includes(window.location.origin) || referrer.includes('/admin/')) {
      localStorage.removeItem('lastVisitedCollection');
      setIsFromLastCollection(false);
      return;
    }


    if (lastCollection === "thinx-last-call-sale") {
      setIsFromLastCollection(true);
    } else {
      setIsFromLastCollection(false);
    }
  }, [currentVariant]);

  const isSaverSet = props.product?.tags?.includes('thinx-set') || props.product?.tags?.includes('tfal-set');
  
  if(isFromLastCollection){
    const newVariants = [];
    const color = [];
    const size = [];
    props.variants.find((variant) => { 
      if(variant.metafields.finalSale === true){
        newVariants.push(variant);
        if(variant.selectedOptions[1].name === "Color"){
          color.push(variant.selectedOptions[1].value)
          size.push(variant.selectedOptions[0].value)
        }else{
          color.push(variant.selectedOptions[0].value)
          size.push(variant.selectedOptions[1].value)
        }
      }
      return false;
    });
    const colour = [...new Set(color)];
    const sizes = [...new Set(size)];
    if(props.option.name === "Color"){
      // eslint-disable-next-line no-param-reassign
      props.option.values = colour;
    }
    if(props.option.name === "Size"){
      // eslint-disable-next-line no-param-reassign
      props.option.values = sizes;
    }
  }
  if (props.option.name.toLowerCase().includes('color') && !isSaverSet) {
    return <SwatchOption {...props} />;
  }
  if (props.option.name.toLowerCase().includes('size')) {
    return <RadioOption {...props} />;
  }
  return (
    <SelectOption
      classes={clsx({ hidden: isSaverSet })}
      {...props}
    />
  );
};

export default VariantSelector;
